export default __webpack_public_path__ + "static/media/kit_14.82fd0af6.jpg";